import _objectWithoutProperties from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// tslint:disable ordered-imports
import cx from 'classnames2';
import React from 'react';
import WindowedSelect, { components, createFilter } from 'react-windowed-select';
import { Description } from '../Description';
import { Header } from '../Header';
import { Icon } from '../Icon';
import { Pill } from '../Pill';
import * as styles from './FilterableInput.scss';
var customStyles = {
  option: function option(defaultStyles) {
    return _objectSpread(_objectSpread({}, defaultStyles), {}, {
      backgroundColor: 'none',
      padding: 0
    });
  }
};
export var FilterableInputPill = function FilterableInputPill(props) {
  var children = props.children;
  return React.createElement("div", {
    className: styles.pill
  }, React.createElement(Pill, {
    size: "small",
    onRemove: props.removeProps.onClick,
    text: children
  }));
};
export var filterConfig = {
  stringify: function stringify(option) {
    return "".concat(option.label, " ").concat(option.value, " ").concat(option.data.meta);
  },
  // To avoid typing lag and avoid calling twice the function stripDiacritics
  // Refers to: https://blog.johnnyreilly.com/2019/04/react-select-with-less-typing-lag.html
  // and original thread https://github.com/JedWatson/react-select/issues/3128
  ignoreAccents: false
};
export var CustomOption = function CustomOption(defaultInnerProps) {
  var _cx;

  var _defaultInnerProps$da = defaultInnerProps.data,
      label = _defaultInnerProps$da.label,
      meta = _defaultInnerProps$da.meta,
      innerProps = defaultInnerProps.innerProps,
      isDisabled = defaultInnerProps.isDisabled,
      isFocused = defaultInnerProps.isFocused,
      isSelected = defaultInnerProps.isSelected; // To avoid performance issues the  onMouseMove, onMouseOver are removed from the innerProps
  // Refer to : https://github.com/JedWatson/react-select/issues/3385
  // and original thread https://github.com/JedWatson/react-select/issues/3128

  var onMouseMove = innerProps.onMouseMove,
      onMouseOver = innerProps.onMouseOver,
      newInnerProps = _objectWithoutProperties(innerProps, ["onMouseMove", "onMouseOver"]); // To avoid issues with te arrow key and the scroll its necessary to use the components.Option
  // Example Link: https://codesandbox.io/s/8kyp183z99
  // Original thread: https://github.com/JedWatson/react-select/issues/2976


  return React.createElement(components.Option, Object.assign({
    className: styles.customOption
  }, defaultInnerProps), React.createElement("div", Object.assign({
    className: cx(styles.option, (_cx = {}, _defineProperty(_cx, styles.isDisabled, isDisabled), _defineProperty(_cx, styles.isFocused, isFocused), _defineProperty(_cx, styles.isSelected, isSelected), _cx))
  }, newInnerProps), React.createElement("div", {
    className: styles.label
  }, label), React.createElement("div", {
    className: styles.meta
  }, meta)));
};
export var CustomClearIndicator = function CustomClearIndicator(defaultInnerProps) {
  var innerProps = defaultInnerProps.innerProps; // To avoid performance issues the  onMouseMove, onMouseOver are removed from the innerProps
  // Refer to : https://github.com/JedWatson/react-select/issues/3385
  // and original thread https://github.com/JedWatson/react-select/issues/3128

  var onMouseMove = innerProps.onMouseMove,
      onMouseOver = innerProps.onMouseOver,
      newInnerProps = _objectWithoutProperties(innerProps, ["onMouseMove", "onMouseOver"]);

  return (// To avoid issues with te arrow key and the scroll its necessary to use the components.Option
    // Example Link: https://codesandbox.io/s/8kyp183z99
    // Original thread: https://github.com/JedWatson/react-select/issues/2976
    React.createElement(components.Option, Object.assign({}, defaultInnerProps), React.createElement("div", Object.assign({}, newInnerProps), React.createElement(Icon, {
      icon: "action-close-small",
      className: styles.clearIcon
    })))
  );
};
export var CustomNoOptionsMessage = function CustomNoOptionsMessage(_ref) {
  var _ref$emptyHeader = _ref.emptyHeader,
      emptyHeader = _ref$emptyHeader === void 0 ? 'Empty' : _ref$emptyHeader,
      _ref$emptyBody = _ref.emptyBody,
      emptyBody = _ref$emptyBody === void 0 ? 'empty' : _ref$emptyBody;
  return React.createElement("div", {
    className: styles.emptyMessage
  }, React.createElement(Header, {
    variant: "h5"
  }, emptyHeader), React.createElement(Description, {
    className: styles.emptyBody
  }, emptyBody));
};
export var FilterableInput = function FilterableInput(props) {
  var value = props.value,
      inputValue = props.inputValue,
      defaultInputValue = props.defaultInputValue,
      defaultValue = props.defaultValue,
      options = props.options,
      onChange = props.onChange,
      variant = props.variant,
      emptyHeader = props.emptyHeader,
      emptyBody = props.emptyBody,
      placeholder = props.placeholder,
      menuPlacement = props.menuPlacement,
      dataTest = props.dataTest;
  var customComponents = variant === 'multi' ? {
    MultiValue: FilterableInputPill,
    DropdownIndicator: function DropdownIndicator() {
      return null;
    },
    IndicatorSeparator: function IndicatorSeparator() {
      return null;
    },
    ClearIndicator: function ClearIndicator() {
      return null;
    },
    Option: CustomOption,
    NoOptionsMessage: CustomNoOptionsMessage.bind(null, {
      emptyHeader: emptyHeader,
      emptyBody: emptyBody
    })
  } : {
    DropdownIndicator: function DropdownIndicator() {
      return null;
    },
    IndicatorSeparator: function IndicatorSeparator() {
      return null;
    },
    ClearIndicator: CustomClearIndicator,
    Option: CustomOption,
    NoOptionsMessage: CustomNoOptionsMessage.bind(null, {
      emptyHeader: emptyHeader,
      emptyBody: emptyBody
    })
  };
  return React.createElement(WindowedSelect, {
    options: options,
    inputValue: inputValue,
    defaultInputValue: defaultInputValue,
    value: value,
    defaultValue: defaultValue,
    isMulti: variant === 'multi',
    isClearable: true,
    components: customComponents,
    filterOption: createFilter(filterConfig),
    onChange: onChange,
    placeholder: placeholder,
    menuPlacement: menuPlacement,
    className: styles.filterableInput,
    styles: customStyles,
    "data-test": dataTest
  });
};